import { h, Transition } from 'vue';

interface IScrimProps {
  [key: string]: unknown;
  modelValue: boolean;
}

export function CdsScrim(props: IScrimProps) {
  const { modelValue, ...rest } = props;

  return h(
    Transition,
    {
      name: 'fade-transition',
      appear: true
    },
    {
      default: () =>
        modelValue &&
        h('div', {
          class: ['cds-overlay__scrim'],
          ...rest
        })
    }
  );
}
